// DS: MO3.4.2
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
const CommissionShopCard = ({ width , deviation , withAuthorDetails , withIndicators  })=>{
    return /*#__PURE__*/ React.createElement(DeviationShopCard, {
        width: width,
        deviation: deviation,
        withStats: false,
        withDescriptionBlock: true,
        withAuthorDetails: withAuthorDetails,
        withIndicators: withIndicators
    });
};
CommissionShopCard.displayName = 'CommissionShopCard';
export default CommissionShopCard;
